
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/user-terms",
      function () {
        return require("private-next-pages/terms/user-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/user-terms"])
      });
    }
  